// src/components/MembershipModal.js
import React from 'react';
import { FaTimes, FaCheckCircle } from 'react-icons/fa';
import { motion, AnimatePresence } from 'framer-motion';

const MembershipModal = ({ isOpen, onClose, membership }) => {
  if (!isOpen || !membership) return null;

  const backdropVariants = {
    hidden: { opacity: 0 },
    visible: { opacity: 1 },
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: { opacity: 1, scale: 1, transition: { duration: 0.3, ease: "easeOut" } },
    exit: { opacity: 0, scale: 0.9, transition: { duration: 0.2, ease: "easeIn" } }
  };

  return (
    <AnimatePresence>
      {isOpen && (
        <motion.div
          className="modal d-block"
          style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}
          variants={backdropVariants}
          initial="hidden"
          animate="visible"
          exit="hidden"
          onClick={onClose}
          tabIndex="-1"
        >
          <motion.div
            className="modal-dialog modal-dialog-centered modal-lg"
            variants={modalVariants}
            initial="hidden"
            animate="visible"
            exit="exit"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content border-0 shadow-lg">
              {/* Header with ARCA Green */}
              <div 
                className="modal-header text-white border-0" 
                style={{ 
                  background: 'linear-gradient(135deg, #6B8E23 0%, #556B1F 100%)'
                }}
              >
                <h2 className="modal-title fs-4 fw-bold mb-0">{membership.name}</h2>
                <button 
                  onClick={onClose} 
                  className="btn-close btn-close-white"
                  type="button"
                  aria-label="Close"
                ></button>
              </div>

              <div className="modal-body p-4 p-md-5">
                {/* Price Section */}
                <div className="text-center mb-4">
                  <p className="display-4 fw-bold mb-2" style={{ color: '#6B8E23' }}>
                    ${membership.price}
                    <span className="fs-5 fw-normal text-muted">/year</span>
                  </p>
                  <p className="text-muted">{membership.description}</p>
                </div>

                {/* Benefits Section */}
                <div>
                  <h3 className="h5 fw-semibold mb-3" style={{ color: '#6B8E23' }}>Key Benefits:</h3>
                  <ul className="list-unstyled">
                    {membership.benefits.map((benefit, index) => (
                      <li key={index} className="d-flex align-items-start mb-3">
                        <FaCheckCircle 
                          className="me-3 mt-1 flex-shrink-0" 
                          style={{ color: '#6B8E23', fontSize: '1.25rem' }}
                        />
                        <span className="text-dark">{benefit}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>

              <div className="modal-footer border-0 px-4 px-md-5 pb-4">
                <motion.button
                  onClick={onClose}
                  className="btn btn-lg w-100 text-white fw-semibold"
                  style={{ backgroundColor: '#6B8E23', borderColor: '#6B8E23' }}
                  whileHover={{ scale: 1.02 }}
                  whileTap={{ scale: 0.98 }}
                >
                  Close
                </motion.button>
              </div>
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default MembershipModal;